import moment from 'moment'

export default {
    namespaced: true,
    state: {
        totals: {},
        loading: true,
        period: 'I dag',
        range: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        excludeWinback: true,
        excludeInactive: false
    },
    mutations: {
        startLoading: (state) => {
            state.loading = true
        },
        stopLoading: (state) => {
            state.loading = false
        },
        setTotals: (state, totals) => {
            state.totals = totals
        },
        setRange: (state, preset) => {
            if (preset === "I dag") {
                // state.range = {
                //     startDate: moment()
                //         .format("YYYY-MM-DD"),
                //     endDate: moment()
                //         .format("YYYY-MM-DD")
                // };
                state.range = [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
            } else if (preset === "I går") {
                state.range = [
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD")
                    ];
            } else if (preset === "Denne uge") {
                state.range = [
                    moment()
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste uge") {
                state.range = [
                    moment()
                        .subtract(1, "weeks")
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "weeks")
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Denne måned") {
                state.range = [
                    moment()
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste måned") {
                state.range = [
                    moment()
                        .subtract(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Dette år") {
                state.range = [
                    moment()
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("year")
                        .format("YYYY-MM-DD")
                ];
            }
        }
    }
}